const CompanyProperty = ({
    listingId = '',
    name = '',
    street = '',
    state = '',
    city = '',
    listingIds = [],
    contactEmail = '',
} = {}) => ({
    listingId: String(listingId),
    name: String(name),
    street: String(street),
    state: String(state),
    city: String(city),
    listingIds,
    contactEmail: String(contactEmail),
});

export default CompanyProperty;
